<template>
    <div>
        <v-container fluid hidden-sm-and-down pa-0>
            <v-jumbotron :gradient="gradient" height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container>
                        <v-layout justify-center>
                            <v-flex xs4 xl3 style="display: flex; align-items: center;">
                                        
                                <v-toolbar-title class="display-2">
                                    Produtos
                                </v-toolbar-title>

                            </v-flex>

                            <v-flex xs4 style="display: flex; align-items: center; justify-content: center;">
                                <v-toolbar-items style="height: 100%;">
                                    <v-tooltip top v-for="list in lists" :key="list.nome" color="primary">
                                        <v-btn  flat :to="list.path" class="subheading"  slot="activator">
                                            <v-avatar :tile="true">
                                                <img :src="getImgSVG(list.img)" :alt="list.nome">
                                            </v-avatar>
                                        </v-btn>

                                        <span class="body-2">{{list.nome}}</span>
                                    </v-tooltip>
                                </v-toolbar-items>
                            </v-flex>

                            <v-flex xs4 xl3 style="display: flex; align-items: center;">
                                <v-spacer></v-spacer>
                                <v-toolbar-items style="height: 100%;">
                                    <v-dialog v-model="dialog" width="75vw">
                                        <v-btn slot="activator" outline class="subheading hidden-xs-only" color="primary" style="height: 50px!important;">Como comprar?</v-btn>

                                        <v-stepper v-model="e1">
                                            <v-stepper-header>
                                                <v-stepper-step :complete="e1 > 1" step="1">Adicionar ao carrinho</v-stepper-step>

                                                <v-divider></v-divider>

                                                <v-stepper-step :complete="e1 > 2" step="2">Gerar PDF</v-stepper-step>

                                                <v-divider></v-divider>

                                                <v-stepper-step step="3">Nos envie</v-stepper-step>
                                            </v-stepper-header>

                                            <v-stepper-items>
                                                <v-stepper-content step="1">
                                                    <v-card class="mb-5" color="" flat height="auto"> 
                                                        <v-container ma-0 pa-0>
                                                            <v-layout align-center pa-3>
                                                                <v-flex xs6>
                                                                    <img src="../assets/part1.svg" alt="Adicionar ao carrinho" style="height: 400px !important;">
                                                                </v-flex>

                                                                <v-flex xs6 text-xs-center>
                                                                    <p class="display-1 mb-3">Adicione o produto ao carrinho</p>
                                                                    <p class="title font-weight-light">Vá até o produto desejado e aperte o botão 
                                                                        azul para adicionar ao carrinho, o vermelho para retirar, ou o preto para 
                                                                        ver mais informações sobre o produto.</p>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card>

                                                    <v-btn color="primary" @click="e1 = 2"> Próximo </v-btn>

                                                    <v-btn flat @click="dialog = !dialog">Sair</v-btn>
                                                </v-stepper-content>

                                                <v-stepper-content step="2">
                                                    <v-card class="mb-5" color="" flat height="auto"> 
                                                        <v-container ma-0 pa-0>
                                                            <v-layout align-center pa-3>
                                                                <v-flex xs6>
                                                                    <img src="../assets/part2.svg" alt="Adicionar ao carrinho" style="height: 400px !important;">
                                                                </v-flex>

                                                                <v-flex xs6 text-xs-center>
                                                                    <p class="display-1 mb-3">Gerar PDF</p>
                                                                    <p class="title font-weight-light">Vá ao menu do site e acesse o carrinho. 
                                                                        Dentro do carrinho, pressione o botão "Gerar PDF" para baixar o PDF com
                                                                        o pedido.</p>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card>

                                                    <v-btn color="primary" @click="e1 = 3"> Próximo </v-btn>

                                                    <v-btn flat @click="dialog = !dialog">Sair</v-btn>
                                                </v-stepper-content>

                                                <v-stepper-content step="3">
                                                    <v-card class="mb-5" color="" flat height="auto"> 
                                                        <v-container ma-0 pa-0>
                                                            <v-layout align-center pa-3>
                                                                <v-flex xs6>
                                                                    <img src="../assets/part3.svg" alt="Adicionar ao carrinho" style="height: 400px !important;">
                                                                </v-flex>

                                                                <v-flex xs6 text-xs-center>
                                                                    <p class="display-1 mb-3">Nos envie seu pedido</p>
                                                                    <p class="title font-weight-light mb-3">Acesse o Whats App do Beco e nos envie seu PDF com
                                                                        os pedidos. Para acessar o Whats App basta pressionar o botão com o simbolo
                                                                        do Whats App no rodapé do site, ou salvar nosso número.</p>
                                                                    <p class="title">Muito obrigado pela preferência, boas compras e ótimos projetos!</p>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card>

                                                    <v-btn color="primary" @click="e1 = 1"> Início </v-btn>

                                                    <v-btn flat @click="dialog = !dialog">Sair</v-btn>
                                                </v-stepper-content>
                                            </v-stepper-items>
                                        </v-stepper>

                                    </v-dialog>
                                </v-toolbar-items>
                            </v-flex>

                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>
                
                <v-content>
                    <v-container fluid style="padding: 0 !important;">
                        <v-layout justify-center>
                            <v-flex xs12 xl10>
                                <v-slide-y-transition mode="out-in">
                                    <router-view></router-view>
                                </v-slide-y-transition>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-content>
                <v-divider class="transparent mb-3"></v-divider>
            </v-jumbotron>      
        </v-container>

        <v-container fluid hidden-md-and-up pa-0>
            <v-jumbotron :gradient="gradient" height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-xs-center>
                        <v-layout>
                            <v-flex xs12>
                    
                                <v-toolbar-title class="display-1">
                                    Produtos
                                </v-toolbar-title>

                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container pt-0 pb-0>
                    <v-layout>
                        <v-flex xs12 justify-center>
                            <v-dialog v-model="dialog2" style="width: 100% !important;" >
                                <v-btn slot="activator" block outline color="primary" class="subheading" >Como comprar?</v-btn>

                                <v-stepper v-model="e1" class="hidden-sm-and-up" >
                                    <v-stepper-header>
                                        <v-stepper-step :complete="e1 > 1" step="1">Adicionar ao carrinho</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step :complete="e1 > 2" step="2">Gerar PDF</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="3">Nos envie</v-stepper-step>
                                    </v-stepper-header>

                                    <v-stepper-items>
                                        <v-stepper-content step="1">
                                            <v-card class="mb-1" color="" flat height="auto"> 
                                                <v-container ma-0 pa-0>
                                                    <v-layout xs12 align-center pa-0 row wrap>
                                                        <v-flex xs12 text-xs-center>
                                                            <p class="headline mb-3 ">Adicione o produto ao carrinho</p>
                                                            <p class="mb-0 subheading font-weight-light">Vá até o produto desejado e aperte o botão 
                                                                azul para adicionar ao carrinho, o vermelho para retirar, ou o preto para 
                                                                ver mais informações sobre o produto.</p>    
                                                            <img src="../assets/part1.svg" alt="Adicionar ao carrinho" style="height: 250px !important;">
                                                            <v-divider class="transparent mb-2"></v-divider>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn color="primary" @click="e1 = 2"> Próximo </v-btn>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn depressed @click="dialog2 = !dialog2">Sair</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>

                                        </v-stepper-content>

                                        <v-stepper-content step="2">
                                            <v-card class="mb-1" color="" flat height="auto"> 
                                                <v-container ma-0 pa-0>
                                                    <v-layout align-center pa-0 row wrap>
                                                        <v-flex xs12 text-xs-center ma-0>
                                                            <p class="headline mb-3">Gerar PDF</p>
                                                            <p class="subheading font-weight-light">Vá ao menu do site e acesse o carrinho. 
                                                                Dentro do carrinho, pressione o botão "Gerar PDF" para baixar o PDF com
                                                                o pedido.</p>
                                                            <img src="../assets/part2.svg" alt="Adicionar ao carrinho" style="height: 150px !important;">
                                                            <v-divider class="transparent mb-2"></v-divider>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn color="primary" @click="e1 = 3"> Próximo </v-btn>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn depressed @click="dialog2 = !dialog2">Sair</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>
                                        </v-stepper-content>

                                        <v-stepper-content step="3">
                                            <v-card class="mb-1" color="" flat height="auto"> 
                                                <v-container ma-0 pa-0>
                                                    <v-layout align-center pa-0 row wrap>
                                                        <v-flex xs12 text-xs-center>
                                                            <p class="headline mb-3">Nos envie seu pedido</p>
                                                            <p class="subheading font-weight-light mb-3">Acesse o Whats App do Beco e nos envie seu PDF com
                                                                os pedidos. Para acessar o Whats App basta pressionar o botão com o simbolo
                                                                do Whats App no rodapé do site, ou salvar nosso número.</p>
                                                            <p class="subheading font-weight-bold">Muito obrigado pela preferência, boas compras e ótimos projetos!</p>
                                                            <img src="../assets/part3.svg" alt="Adicionar ao carrinho" style="height: 200px !important;">
                                                            <v-divider class="transparent mb-2"></v-divider>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn color="primary" @click="e1 = 1"> Início </v-btn>
                                                        </v-flex>

                                                        <v-flex xs6 text-xs-center justify-center>
                                                            <v-btn depressed @click="dialog2 = !dialog2">Sair</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>

                            </v-dialog>
                        </v-flex>
                    </v-layout>
                </v-container>
                
                <v-content>
                    <v-container fluid style="padding: 0 !important;">
                        <v-layout>
                            <v-flex xs12>
                                <v-slide-y-transition mode="out-in">
                                    <router-view></router-view>
                                </v-slide-y-transition>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-content>

                <v-divider class="transparent"></v-divider>
            </v-jumbotron> 

            <v-speed-dial v-model="fab" :bottom="true" :right="true" :direction="'top'" :open-on-hover="false" fixed>
                <v-btn slot="activator" v-model="fab" color="primary" dark fab>
                    <v-icon>fas fa-arrow-alt-circle-up</v-icon>
                    <v-icon>fas fa-times</v-icon>
                </v-btn>

                <v-tooltip left v-for="list in lists" :key="list.nome" color="primary">
                    <v-btn small fab flat :to="list.path" class="subheading mb-3" slot="activator">
                        <v-avatar :tile="true" size="45px">
                            <img :src="getImgSVG(list.img)" :alt="list.nome">
                        </v-avatar>
                    </v-btn>

                    <span class="body-2">{{list.nome}}</span>
                </v-tooltip>

            </v-speed-dial>
        </v-container>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                gradient: 'to top, rgba(0,0,0,0.1), rgba(0,0,0,0.0)',
                lists: [
                    {nome: 'Arduino', img: 'arduino', path: 'arduino'},
                    {nome: 'Robótica', img: 'robocop', path: 'robotica'},
                    {nome: 'Prototipagem', img: 'multimeter', path: 'prototipagem'},
                    {nome: 'Componentes', img: 'led-light', path: 'componentes'}
                ],
                fab: false,
                dialog: false,
                dialog2: false,
                e1: 0
            }
        },
        methods:{
            getImgSVG(path) {
                var images = require.context('../assets/', false, /\.svg$/)
                return images('./' + path + '.svg')
            },
            goTo(path){
                this.$router.push({path: '/products/' + path})
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/products.vue